var map = {
	"./card-amex.svg": [
		50696,
		696
	],
	"./card-diners.svg": [
		30122,
		122
	],
	"./card-discover.svg": [
		5862,
		5862
	],
	"./card-jcb.svg": [
		92107,
		2107
	],
	"./card-mastercard.svg": [
		21852,
		1852
	],
	"./card-reader-outline.svg": [
		67223,
		7223
	],
	"./card-unionpay.svg": [
		86309,
		6309
	],
	"./card-visa.svg": [
		23618,
		8228
	],
	"./gg-bottle-pump-line.svg": [
		9271,
		9271
	],
	"./gg-card-clock-line.svg": [
		56034,
		6034
	],
	"./gg-cellular-line.svg": [
		56721,
		1033
	],
	"./gg-gloss-symbol-fill.svg": [
		9225,
		9225
	],
	"./gg-gloss-word-fill.svg": [
		7970,
		7970
	],
	"./gg-salon-chair-fill.svg": [
		45455,
		5455
	],
	"./gg-scan-line.svg": [
		66895,
		6895
	],
	"./gg-yelp-circle.svg": [
		97200,
		7200
	],
	"./gg-yelp.svg": [
		25315,
		5315
	],
	"./gloss-genius.svg": [
		37705,
		7705
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 27216;
module.exports = webpackAsyncContext;